import { Helmet } from 'react-helmet';

interface ISEOProps {
  title: string;
  description?: string;
  url?: string;
  image?: string;
  canonical?: string;
  indexable?: boolean;
}

export const SEO = ({ title, description, url, image, canonical, indexable }: ISEOProps) => {
  const mainUrl = url || process.env.REACT_APP_SITE_URL;
  const mainImage = image || `${process.env.REACT_APP_SITE_URL}og-image.png`;

  return (
    <Helmet>
      <title>{title}</title>
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="robots" content={indexable ? 'index, follow' : 'noindex'} />
      <meta name="description" content={description} key="description" />
      <meta property="og:title" content={title} key="og:title" />
      <meta
        property="og:description"
        content={description || 'BigDevSoon - You and Code Frames in the center'}
        key="og:description"
      />
      <meta property="og:url" content={mainUrl} key="og:url" />
      <meta property="og:site_name" content="BigDevSoon" key="og:site_name" />
      <meta property="og:type" content="website" key="og:type" />
      <meta property="og:image" content={mainImage} key="og:image" />
      <meta name="twitter:card" content="summary_large_image" key="twitter:card" />
      <meta name="twitter:title" content={title} key="twitter:title" />
      <meta name="twitter:site" content="app.bigdevsoon.me" key="twitter:site" />
      <meta name="twitter:creator" content="Adrian Bigaj" key="twitter:creator" />
      <meta name="twitter:description" content={description} key="twitter:description" />
      <meta name="twitter:image" content={mainImage} key="twitter:image" />
    </Helmet>
  );
};
